import {
    getDoc, doc,
    Timestamp, runTransaction
} from "firebase/firestore";
import { db } from "../config/firebase";



export const getFavoriteEvents = async (userId) => {
  try {
    const favoriteRef = doc(db, 'favoritesEvents', userId);
    const docSnap = await getDoc(favoriteRef);

    if (docSnap.exists()) {
      const events = docSnap.data().events || [];
      events.sort((a, b) => b.favoritedAt.toDate() - a.favoritedAt.toDate());
      return events;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error getting favorites: ", error);
    return [];
  }
};

export const addFavoriteEvents = async (userId, events) => {
    const favoriteRef = doc(db, 'favoritesEvents', userId);
    
    try {
        await runTransaction(db, async (transaction) => {
        const favoriteDoc = await transaction.get(favoriteRef);
    
        if (!favoriteDoc.exists()) {
            // If document doesn't exist, create it with the new favorite
            transaction.set(favoriteRef, {
            userId: userId,
            events: events.map(event =>
                ({ eventId: event.eventId, favoritedAt: new Timestamp(event.favoritedAt) }))
            });
        } else {
            const favoriteData = favoriteDoc.data();
            if (!favoriteData || !favoriteData.events) {
                favoriteData.events = [];
            }
            
            // check favoritedAt type before adding to the array

            events.forEach(event => {
                if (!(event.favoritedAt instanceof Timestamp)) {
                    event.favoritedAt = Timestamp.fromDate(new Date(event.favoritedAt));
                }
            });

            
            transaction.update(favoriteRef, { events: events });
        }
        });
        return { success: true };
    } catch (error) {
        console.error("Error adding favorite: ", error);
        return { success: false, message: "Error adding favorite" };
    }
};

export const addFavoriteEvent = async (userId, eventId) => {
  const favoriteRef = doc(db, 'favoritesEvents', userId);

  try {
    await runTransaction(db, async (transaction) => {
      const favoriteDoc = await transaction.get(favoriteRef);

      if (!favoriteDoc.exists()) {
        // If document doesn't exist, create it with the new favorite
        transaction.set(favoriteRef, {
          userId: userId,
          events: [{ eventId: eventId, favoritedAt: Timestamp.now() }]
        });
      } else {
        const favoriteData = favoriteDoc.data();
        if (!favoriteData || !favoriteData.events) {
          favoriteData.events = [];
        }
        favoriteData.events.push({ eventId: eventId, favoritedAt: Timestamp.now() });
        transaction.update(favoriteRef, { events: favoriteData.events });
      }
    });
    return { success: true };
  } catch (error) {
    console.error("Error adding favorite: ", error);
    return { success: false, message: "Error adding favorite" };
  }
};

export const removeFavoriteEvent = async (userId, eventId) => {
  try {
    const favoriteRef = doc(db, 'favoritesEvents', userId);

    await runTransaction(db, async (transaction) => {
      const favoriteDoc = await transaction.get(favoriteRef);

      if (favoriteDoc.exists) {
        let events = favoriteDoc.data().events || [];
        const updatedEvents = events.filter(e => e.eventId !== eventId);

        if (events.length !== updatedEvents.length) {
          transaction.update(favoriteRef, { events: updatedEvents });
        }
      }
    });

    // return success message
    return { success: true };
  } catch (error) {
    console.error("Error removing favorite: ", error);
    return { success: false, message: "Error removing favorite" };
  }
};